module.exports = __webpack_public_path__ + "front/img/contentbg的副本.6bc93e15.jpg";